<div class="auto-payments">
  <form [formGroup]="visitAutoPaymentsForm">

    <div class="auto-payments-header">
      <div class="form-group" style="width: 210px">
        <label for="currency">Auto-payment type</label>
        <app-dropdown-input #autoPaymentTypeSelect id="autoPaymentType" [options]="autoPaymentTypes"
                            [parentForm]="visitAutoPaymentsForm" name="autoPaymentType"
                            placeholder="Select Auto Payment Type"></app-dropdown-input>
      </div>

      <div class="checkbox-wrap">
        <div class="form-group checkbox-input-field">
          <label class="checkbox input-checkbox">
            <input type="checkbox" id="assumeVisitAttendance" formControlName="assumeVisitAttendance"
                   value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="assumeVisitAttendance">Assume visit attendance after <input
            formControlName="assumeVisitAttendanceAfterDays" class="days-input" type="number"> days</label>
        </div>
      </div>

      <div class="form-group" style="width: 210px">
        <label for="currency">Auto-payment currency</label>
        <app-dropdown-input #currencySelect id="autoPaymentCurrency" [options]="currencies"
                            [parentForm]="visitAutoPaymentsForm" name="autoPaymentCurrency" placeholder="Select currency">
        </app-dropdown-input>
      </div>
    </div>

    <div>
      <div class="visit-headings">
        <span class="visit-key-visit">
          <label class="checkbox select-all-checkbox" *ngIf="visits.length"
                 [title]="allKeyVisitsSelected ? 'Deselect all' : 'Select all'">
            <input type="checkbox" [checked]="allKeyVisitsSelected"
                   [indeterminate]="someKeyVisitsSelected" (change)="onToggleAllKeyVisits($event)">
            <span></span>
          </label>
          <span class="select-all-label">Key Visit</span>
        </span>
        <span class="visit-name">Visit</span>
        <span class="visit-amount">
          <span class="col-label">Patient Amount</span>
          <div class="bulk-update" *ngIf="visits.length" (clickOutside)="closeBulkUpdateFor('amount')">
            <button type="button" class="btn-bulk-update" (click)="openBulkUpdate('amount')">Bulk Update</button>
            <ng-container *ngIf="openBulkField === 'amount'"
                          [ngTemplateOutlet]="bulkUpdatePopover"></ng-container>
          </div>
        </span>
        <span class="visit-caregiver-amount">
          <span class="col-label">Caregiver Amount</span>
          <div class="bulk-update" *ngIf="visits.length" (clickOutside)="closeBulkUpdateFor('caregiverAmount')">
            <button type="button" class="btn-bulk-update" (click)="openBulkUpdate('caregiverAmount')">Bulk Update</button>
            <ng-container *ngIf="openBulkField === 'caregiverAmount'"
                          [ngTemplateOutlet]="bulkUpdatePopover"></ng-container>
          </div>
        </span>
      </div>
      <div class="visit-box" *ngFor="let visit of visits">
        <span class="visit-key-visit">
          <label class="checkbox">
            <input type="checkbox" id="keyVisit" (change)="onKeyVisitChecked(visit, $event)"
                   [checked]="visit.keyVisit">
            <span></span>
          </label>
        </span>
        <span class="visit-name">{{ visit.title }}</span>
        <span class="visit-amount">
          <input [disabled]="!visit.keyVisit" #amount class="amount-input" type="number" placeholder="0.00"
                 (blur)="onAmountSet(visit, amount.value)" [value]="visit.amount ? visit.amount.toFixed(2) : ''">
        </span>
        <span class="visit-caregiver-amount">
          <input [disabled]="!visit.keyVisit" #caregiverAmount class="amount-input" type="number" placeholder="0.00"
                 (blur)="onCaregiverAmountSet(visit, caregiverAmount.value)" [value]="visit.caregiverAmount ? visit.caregiverAmount.toFixed(2) : ''">
        </span>
      </div>
    </div>

  </form>

  <div class="auto-payments-footer">
    <a routerLink="/trial/{{trialId}}" fragment="policies" class="btn btn-secondary">Cancel</a>
    <button class="btn btn-primary" type="submit" [disabled]="visitAutoPaymentsForm.invalid"
            (click)="onSave()">
      <span *ngIf="visitAutoPaymentsForm.get('isBusy').value">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span class="sr-only">Loading...</span>
                        </span>
      <span *ngIf="!visitAutoPaymentsForm.get('isBusy').value">Save</span>
    </button>
  </div>
</div>

<ng-template #bulkUpdatePopover>
  <div class="bulk-update-popover" [formGroup]="bulkForm">
    <div class="bulk-target-switch">
      <button type="button" class="switch-btn"
              [class.active]="bulkForm.controls.target.value === 'all'"
              (click)="bulkForm.controls.target.setValue('all')">All Visits</button>
      <button type="button" class="switch-btn"
              [class.active]="bulkForm.controls.target.value === 'key'"
              (click)="bulkForm.controls.target.setValue('key')">Key Visits</button>
    </div>
    <label class="bulk-update-label">{{ bulkFieldLabel }} <span class="required">*</span></label>
    <input class="bulk-update-input" type="number" formControlName="amount" placeholder="Enter amount...">
    <div class="bulk-update-actions">
      <app-button type="button" variant="secondary" size="sm" text="Cancel"
                  (clicked)="closeBulkUpdate()"></app-button>
      <app-button type="button" variant="primary" size="sm" text="Apply"
                  (clicked)="applyBulkUpdate()"></app-button>
    </div>
  </div>
</ng-template>
